export const StatusWaterfallFilterOptions = {
  All: 1,
  AllEnabled: 2,
};
